import { render } from "./DeductionsTable.vue?vue&type=template&id=4a2bfe18&scoped=true"
import script from "./DeductionsTable.vue?vue&type=script&lang=js"
export * from "./DeductionsTable.vue?vue&type=script&lang=js"

import "./DeductionsTable.vue?vue&type=style&index=0&id=4a2bfe18&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a2bfe18"]])

export default __exports__